import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(1),
    verticalAlign: -3,
  },
}))
